import { useCallback } from 'react';

import { useLazyPassengersRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { useLazyRoutesRouteTemplateDataRetrieveQuery } from 'src/common/external/bambi-api/routesApi';

export function useLazyHydrateRouteTemplateData() {
  const [fetchRouteTemplate, { isLoading: isFetchingRouteTemplate }] =
    useLazyRoutesRouteTemplateDataRetrieveQuery();

  const [fetchPassenger, { isLoading: isFetchingPassenger }] =
    useLazyPassengersRetrieveQuery();

  const fetchRouteTemplateData = useCallback(
    async (id: string) => {
      const routeTemplateData = await fetchRouteTemplate({
        id,
      }).unwrap();
      const uniquePassengerIds = [
        ...new Set(
          routeTemplateData.trip_templates.map(
            (tripTemplate) => tripTemplate.passenger_id
          )
        ),
      ];
      const passengers = await Promise.all(
        uniquePassengerIds.map((passengerId) =>
          fetchPassenger({ id: passengerId }).unwrap()
        )
      );

      return {
        ...routeTemplateData,
        trip_templates: routeTemplateData.trip_templates.map(
          (tripTemplate) => ({
            ...tripTemplate,
            passenger: passengers.find(
              (passenger) => passenger.id === tripTemplate.passenger_id
            ),
          })
        ),
      };
    },
    [fetchPassenger, fetchRouteTemplate]
  );

  return {
    fetchRouteTemplateData,
    isLoading: isFetchingRouteTemplate || isFetchingPassenger,
  };
}
